import { Container } from "@chakra-ui/react";
import { InlineModalButtonFragment } from "src/__generated__/cms-schema.codegen";
import { CMSModalButton } from "src/components/CMSButton/CMSModalButton";
import { DatoAsset, DatoAssetData } from "src/components/Dato/DatoAsset";
import { Hx } from "src/components/Heading/Heading";

type Item = {
	image: DatoAssetData;
	label: string;
};
export type ActionTeaserSectionProps = {
	title: string;
	subtitle: string;
	items: Array<Item>;
	button: InlineModalButtonFragment;
};
export const ActionTeaserSection: React.FC<ActionTeaserSectionProps> = ({
	title,
	subtitle,
	items,
	button,
}) => {
	return (
		<Container
			maxW="container.xl"
			className="text-brand-blue flex flex-col items-center text-center gap-3 py-20 px-4"
		>
			<Hx size="h2">{title}</Hx>
			<p>{subtitle}</p>
			<div className="flex flex-col md:flex-row md:gap-10 gap-5 items-center py-10">
				{items.map(({ image, label }) => (
					<div key={label} className="flex items-center flex-col">
						<div className="w-20 h-20">
							<DatoAsset
								data={image}
								h={20}
								datoImageProps={{
									objectFit: "cover",
								}}
							/>
						</div>
						<span className="font-medium">{label}</span>
					</div>
				))}
			</div>
			<CMSModalButton {...button} />
		</Container>
	);
};

// 🔬 e2e: story
